import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuth, useUser } from "@clerk/clerk-react";
import { useNavigate, useLocation } from "react-router-dom";
import { identifyAnalytics } from "src/pages/helpers";
import { getClerkUserEmail } from "src/utils/clerkUserIdentity";
import { isClaudeConnectorEnabled } from "src/utils/claudeConnectorFlag";

const useValidatePageAccess = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userMetadata = useSelector((state) => state.onboarding.userMetadata);

  // Capture the checkout tier at render time, before CheckoutFlowModal's
  // useSyncURLFromState effect can strip modal params from the URL.
  // useRef initializes synchronously during render (before any effects run).
  const checkoutTierRef = useRef(new URLSearchParams(location.search).get("tier"));
  // Same for the checkout entry (e.g. "get_started"), so it survives the bounce through /signin.
  const checkoutEntryRef = useRef(new URLSearchParams(location.search).get("entry"));

  const { getToken, isLoaded, isSignedIn } = useAuth();
  const { user } = useUser();

  useEffect(() => {
    const getMyToken = async () => {
      const token = await getToken({ template: "Backend" });
      return token;
    };
    const getTokenValue = async () => {
      const token = await getMyToken();
      if (token && typeof token === "string") {
        localStorage.setItem("accessToken2", token);
      }
    };
    getTokenValue();
  }, [getToken]);

  useEffect(() => {
    setInterval(() => {
      if (isSignedIn) {
        // // console.log("clerk  is signed in");
        const getMyToken = async () => {
          const token = await getToken({ template: "Backend" });
          // // console.log("token from clerk", token);
          return token;
        };

        const getTokenValue = async () => {
          // // console.log("f-t");
          const token = await getMyToken();
          // // console.log("f-ed-t", JSON.stringify(token));
          if (token && typeof token === "string") {
            localStorage.setItem("accessToken2", token);
            // // console.log("t set", token);
          } else {
            // // console.log("t invalid", JSON.stringify(token));
          }
        };
        if (isSignedIn) {
          getTokenValue();
        }
      }
    }, 30000);
  }, [isSignedIn, getToken]);

  useEffect(() => {
    if (isLoaded) {
      if (isSignedIn) {
        const getMyToken = async () => {
          const token = await getToken({ template: "Backend" });
          return token;
        };

        const getTokenValue = async () => {
          const token = await getMyToken();
          // // console.log("line 56, token=", token);
          if (token && typeof token === "string") {
            localStorage.setItem("accessToken2", token);
          }
        };
        // this is called to ensure that the
        // // console.log("line 65", isSignedIn);
        if (isSignedIn) {
          // // console.log("line 67, getting token value");
          getTokenValue();
        }
      } else {
        // // console.log(`user is not signed in. lined 72.`);
        // // console.log("not signed in. clearking local");
        localStorage.removeItem("accessToken2");
        localStorage.removeItem("refreshToken2");
        localStorage.removeItem("user");
        localStorage.removeItem("userType");
        localStorage.removeItem("client_details");
        localStorage.removeItem("lawyer_info");
        localStorage.removeItem("showForm");
        if (window.location.href.toLowerCase().search("/shared/") === -1) {
          const tier = checkoutTierRef.current;
          const entry = checkoutEntryRef.current;
          let signinUrl = tier ? `/signin?checkout_tier=${encodeURIComponent(tier)}` : "/signin";
          if (tier && entry) signinUrl += `&entry=${encodeURIComponent(entry)}`;
          // INH-5704: a landing with an intent (the Claude connector's /home?source=claude&intent=consultation)
          // comes back to the same URL after sign-in; PostAuth follows redirect_url first.
          // Behind REACT_APP_CLAUDE_CONNECTOR_ENABLED (src/utils/claudeConnectorFlag.ts): off, the plain /signin.
          if (isClaudeConnectorEnabled() && new URLSearchParams(location.search).get("intent")) {
            const returnTo = `${location.pathname}${location.search}`;
            signinUrl += `${tier ? "&" : "?"}redirect_url=${encodeURIComponent(returnTo)}`;
          }
          navigate(signinUrl);
        }
      }
    }
  }, [isLoaded, isSignedIn, navigate, getToken]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const email = getClerkUserEmail(user);
    if (email && userMetadata) {
      setTimeout(() => {
        identifyAnalytics(email, userMetadata, dispatch);
      }, 1000);
    }
  }, [user, userMetadata, dispatch]);
};

export default useValidatePageAccess;
